import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const phoneNumber = "994506555501";
  const message = "Salam! PolyMax Medicine haqqında məlumat almaq istəyirəm.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed right-4 bottom-4 md:right-6 md:bottom-6 z-50 bg-[#25d366] text-white p-4 rounded-full shadow-lg hover:scale-110 transition-transform whatsapp-btn"
      data-testid="whatsapp-button"
      aria-label="WhatsApp ilə əlaqə"
    >
      <MessageCircle className="h-7 w-7" fill="white" />
    </a>
  );
};

export default WhatsAppButton;
